module.exports = __webpack_public_path__ + "static/media/p7.07a551b9.png";